module.exports = __webpack_public_path__ + "static/media/Slide37.3e8af777.JPG";